import { render } from "./ConcessionDeclaration.vue?vue&type=template&id=11731cc4&scoped=true"
import script from "./ConcessionDeclaration.vue?vue&type=script&lang=js"
export * from "./ConcessionDeclaration.vue?vue&type=script&lang=js"

import "./ConcessionDeclaration.vue?vue&type=style&index=0&id=11731cc4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11731cc4"]])

export default __exports__